export default class TokenError extends Error {
}